import { render } from "./ExtrasInterface.vue?vue&type=template&id=297161e2&scoped=true"
import script from "./ExtrasInterface.vue?vue&type=script&lang=js"
export * from "./ExtrasInterface.vue?vue&type=script&lang=js"

import "./ExtrasInterface.vue?vue&type=style&index=0&id=297161e2&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297161e2"]])

export default __exports__